import { Component, Input } from '@angular/core';
import { TrackToolStep } from '@analytics/models';
import { ScEmailFormInput } from '@innogy/sitecore-forms/models';
import { FormState } from 'ngrx-forms';
import { EmailComponent } from '@innogy/common-ui/forms';
import { AutocompleteDirective } from '@innogy/utils-deprecated';

@Component({
  selector: 'wl-sc-email[control][fields][trackStep]',
  templateUrl: './sc-email.component.html',
  standalone: true,
  imports: [EmailComponent, AutocompleteDirective],
})
export class ScEmailComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() control!: FormState<string>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fields!: ScEmailFormInput;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() floatingLabel = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() trackStep!: TrackToolStep;

  get isEmailValidation(): boolean {
    return this.fields.IsValidation.value ?? false;
  }
}
